/**
 * Catálogo de países: código ISO 3166-1 alfa-2 y nombre en castellano.
 *
 * Lo que se guarda es el CÓDIGO, nunca el nombre. Dos razones: el nombre cambia
 * —«Chequia», «República Checa»— y el código no, y agrupar por texto libre
 * obliga a normalizar a mano lo que escribió cada uno. Con el código, la
 * pantalla decide cómo se escribe y la base guarda una sola cosa.
 *
 * Está la lista oficial completa, no un recorte de «donde se juega al dominó»:
 * un recorte deja a alguien afuera sin más salida que una versión nueva de la
 * app, y el que queda afuera es siempre el caso que no se previó.
 *
 * Declarado en orden de código para poder revisarlo contra la norma; se exporta
 * ordenado por nombre, que es como se lee en un selector.
 */

export interface Pais {
  /** ISO 3166-1 alfa-2, en mayúsculas. */
  codigo: string
  nombre: string
}

const CATALOGO: readonly Pais[] = [
  { codigo: 'AD', nombre: 'Andorra' },
  { codigo: 'AE', nombre: 'Emiratos Árabes Unidos' },
  { codigo: 'AF', nombre: 'Afganistán' },
  { codigo: 'AG', nombre: 'Antigua y Barbuda' },
  { codigo: 'AI', nombre: 'Anguila' },
  { codigo: 'AL', nombre: 'Albania' },
  { codigo: 'AM', nombre: 'Armenia' },
  { codigo: 'AO', nombre: 'Angola' },
  { codigo: 'AQ', nombre: 'Antártida' },
  { codigo: 'AR', nombre: 'Argentina' },
  { codigo: 'AS', nombre: 'Samoa Americana' },
  { codigo: 'AT', nombre: 'Austria' },
  { codigo: 'AU', nombre: 'Australia' },
  { codigo: 'AW', nombre: 'Aruba' },
  { codigo: 'AX', nombre: 'Islas Åland' },
  { codigo: 'AZ', nombre: 'Azerbaiyán' },
  { codigo: 'BA', nombre: 'Bosnia y Herzegovina' },
  { codigo: 'BB', nombre: 'Barbados' },
  { codigo: 'BD', nombre: 'Bangladés' },
  { codigo: 'BE', nombre: 'Bélgica' },
  { codigo: 'BF', nombre: 'Burkina Faso' },
  { codigo: 'BG', nombre: 'Bulgaria' },
  { codigo: 'BH', nombre: 'Baréin' },
  { codigo: 'BI', nombre: 'Burundi' },
  { codigo: 'BJ', nombre: 'Benín' },
  { codigo: 'BL', nombre: 'San Bartolomé' },
  { codigo: 'BM', nombre: 'Bermudas' },
  { codigo: 'BN', nombre: 'Brunéi' },
  { codigo: 'BO', nombre: 'Bolivia' },
  { codigo: 'BQ', nombre: 'Caribe Neerlandés' },
  { codigo: 'BR', nombre: 'Brasil' },
  { codigo: 'BS', nombre: 'Bahamas' },
  { codigo: 'BT', nombre: 'Bután' },
  { codigo: 'BV', nombre: 'Isla Bouvet' },
  { codigo: 'BW', nombre: 'Botsuana' },
  { codigo: 'BY', nombre: 'Bielorrusia' },
  { codigo: 'BZ', nombre: 'Belice' },
  { codigo: 'CA', nombre: 'Canadá' },
  { codigo: 'CC', nombre: 'Islas Cocos' },
  { codigo: 'CD', nombre: 'República Democrática del Congo' },
  { codigo: 'CF', nombre: 'República Centroafricana' },
  { codigo: 'CG', nombre: 'Congo' },
  { codigo: 'CH', nombre: 'Suiza' },
  { codigo: 'CI', nombre: 'Costa de Marfil' },
  { codigo: 'CK', nombre: 'Islas Cook' },
  { codigo: 'CL', nombre: 'Chile' },
  { codigo: 'CM', nombre: 'Camerún' },
  { codigo: 'CN', nombre: 'China' },
  { codigo: 'CO', nombre: 'Colombia' },
  { codigo: 'CR', nombre: 'Costa Rica' },
  { codigo: 'CU', nombre: 'Cuba' },
  { codigo: 'CV', nombre: 'Cabo Verde' },
  { codigo: 'CW', nombre: 'Curazao' },
  { codigo: 'CX', nombre: 'Isla de Navidad' },
  { codigo: 'CY', nombre: 'Chipre' },
  { codigo: 'CZ', nombre: 'Chequia' },
  { codigo: 'DE', nombre: 'Alemania' },
  { codigo: 'DJ', nombre: 'Yibuti' },
  { codigo: 'DK', nombre: 'Dinamarca' },
  { codigo: 'DM', nombre: 'Dominica' },
  { codigo: 'DO', nombre: 'República Dominicana' },
  { codigo: 'DZ', nombre: 'Argelia' },
  { codigo: 'EC', nombre: 'Ecuador' },
  { codigo: 'EE', nombre: 'Estonia' },
  { codigo: 'EG', nombre: 'Egipto' },
  { codigo: 'EH', nombre: 'Sáhara Occidental' },
  { codigo: 'ER', nombre: 'Eritrea' },
  { codigo: 'ES', nombre: 'España' },
  { codigo: 'ET', nombre: 'Etiopía' },
  { codigo: 'FI', nombre: 'Finlandia' },
  { codigo: 'FJ', nombre: 'Fiyi' },
  { codigo: 'FK', nombre: 'Islas Malvinas' },
  { codigo: 'FM', nombre: 'Micronesia' },
  { codigo: 'FO', nombre: 'Islas Feroe' },
  { codigo: 'FR', nombre: 'Francia' },
  { codigo: 'GA', nombre: 'Gabón' },
  { codigo: 'GB', nombre: 'Reino Unido' },
  { codigo: 'GD', nombre: 'Granada' },
  { codigo: 'GE', nombre: 'Georgia' },
  { codigo: 'GF', nombre: 'Guayana Francesa' },
  { codigo: 'GG', nombre: 'Guernsey' },
  { codigo: 'GH', nombre: 'Ghana' },
  { codigo: 'GI', nombre: 'Gibraltar' },
  { codigo: 'GL', nombre: 'Groenlandia' },
  { codigo: 'GM', nombre: 'Gambia' },
  { codigo: 'GN', nombre: 'Guinea' },
  { codigo: 'GP', nombre: 'Guadalupe' },
  { codigo: 'GQ', nombre: 'Guinea Ecuatorial' },
  { codigo: 'GR', nombre: 'Grecia' },
  { codigo: 'GS', nombre: 'Islas Georgias del Sur y Sandwich del Sur' },
  { codigo: 'GT', nombre: 'Guatemala' },
  { codigo: 'GU', nombre: 'Guam' },
  { codigo: 'GW', nombre: 'Guinea-Bisáu' },
  { codigo: 'GY', nombre: 'Guyana' },
  { codigo: 'HK', nombre: 'Hong Kong' },
  { codigo: 'HM', nombre: 'Islas Heard y McDonald' },
  { codigo: 'HN', nombre: 'Honduras' },
  { codigo: 'HR', nombre: 'Croacia' },
  { codigo: 'HT', nombre: 'Haití' },
  { codigo: 'HU', nombre: 'Hungría' },
  { codigo: 'ID', nombre: 'Indonesia' },
  { codigo: 'IE', nombre: 'Irlanda' },
  { codigo: 'IL', nombre: 'Israel' },
  { codigo: 'IM', nombre: 'Isla de Man' },
  { codigo: 'IN', nombre: 'India' },
  { codigo: 'IO', nombre: 'Territorio Británico del Océano Índico' },
  { codigo: 'IQ', nombre: 'Irak' },
  { codigo: 'IR', nombre: 'Irán' },
  { codigo: 'IS', nombre: 'Islandia' },
  { codigo: 'IT', nombre: 'Italia' },
  { codigo: 'JE', nombre: 'Jersey' },
  { codigo: 'JM', nombre: 'Jamaica' },
  { codigo: 'JO', nombre: 'Jordania' },
  { codigo: 'JP', nombre: 'Japón' },
  { codigo: 'KE', nombre: 'Kenia' },
  { codigo: 'KG', nombre: 'Kirguistán' },
  { codigo: 'KH', nombre: 'Camboya' },
  { codigo: 'KI', nombre: 'Kiribati' },
  { codigo: 'KM', nombre: 'Comoras' },
  { codigo: 'KN', nombre: 'San Cristóbal y Nieves' },
  { codigo: 'KP', nombre: 'Corea del Norte' },
  { codigo: 'KR', nombre: 'Corea del Sur' },
  { codigo: 'KW', nombre: 'Kuwait' },
  { codigo: 'KY', nombre: 'Islas Caimán' },
  { codigo: 'KZ', nombre: 'Kazajistán' },
  { codigo: 'LA', nombre: 'Laos' },
  { codigo: 'LB', nombre: 'Líbano' },
  { codigo: 'LC', nombre: 'Santa Lucía' },
  { codigo: 'LI', nombre: 'Liechtenstein' },
  { codigo: 'LK', nombre: 'Sri Lanka' },
  { codigo: 'LR', nombre: 'Liberia' },
  { codigo: 'LS', nombre: 'Lesoto' },
  { codigo: 'LT', nombre: 'Lituania' },
  { codigo: 'LU', nombre: 'Luxemburgo' },
  { codigo: 'LV', nombre: 'Letonia' },
  { codigo: 'LY', nombre: 'Libia' },
  { codigo: 'MA', nombre: 'Marruecos' },
  { codigo: 'MC', nombre: 'Mónaco' },
  { codigo: 'MD', nombre: 'Moldavia' },
  { codigo: 'ME', nombre: 'Montenegro' },
  { codigo: 'MF', nombre: 'San Martín' },
  { codigo: 'MG', nombre: 'Madagascar' },
  { codigo: 'MH', nombre: 'Islas Marshall' },
  { codigo: 'MK', nombre: 'Macedonia del Norte' },
  { codigo: 'ML', nombre: 'Malí' },
  { codigo: 'MM', nombre: 'Myanmar' },
  { codigo: 'MN', nombre: 'Mongolia' },
  { codigo: 'MO', nombre: 'Macao' },
  { codigo: 'MP', nombre: 'Islas Marianas del Norte' },
  { codigo: 'MQ', nombre: 'Martinica' },
  { codigo: 'MR', nombre: 'Mauritania' },
  { codigo: 'MS', nombre: 'Montserrat' },
  { codigo: 'MT', nombre: 'Malta' },
  { codigo: 'MU', nombre: 'Mauricio' },
  { codigo: 'MV', nombre: 'Maldivas' },
  { codigo: 'MW', nombre: 'Malaui' },
  { codigo: 'MX', nombre: 'México' },
  { codigo: 'MY', nombre: 'Malasia' },
  { codigo: 'MZ', nombre: 'Mozambique' },
  { codigo: 'NA', nombre: 'Namibia' },
  { codigo: 'NC', nombre: 'Nueva Caledonia' },
  { codigo: 'NE', nombre: 'Níger' },
  { codigo: 'NF', nombre: 'Isla Norfolk' },
  { codigo: 'NG', nombre: 'Nigeria' },
  { codigo: 'NI', nombre: 'Nicaragua' },
  { codigo: 'NL', nombre: 'Países Bajos' },
  { codigo: 'NO', nombre: 'Noruega' },
  { codigo: 'NP', nombre: 'Nepal' },
  { codigo: 'NR', nombre: 'Nauru' },
  { codigo: 'NU', nombre: 'Niue' },
  { codigo: 'NZ', nombre: 'Nueva Zelanda' },
  { codigo: 'OM', nombre: 'Omán' },
  { codigo: 'PA', nombre: 'Panamá' },
  { codigo: 'PE', nombre: 'Perú' },
  { codigo: 'PF', nombre: 'Polinesia Francesa' },
  { codigo: 'PG', nombre: 'Papúa Nueva Guinea' },
  { codigo: 'PH', nombre: 'Filipinas' },
  { codigo: 'PK', nombre: 'Pakistán' },
  { codigo: 'PL', nombre: 'Polonia' },
  { codigo: 'PM', nombre: 'San Pedro y Miquelón' },
  { codigo: 'PN', nombre: 'Islas Pitcairn' },
  { codigo: 'PR', nombre: 'Puerto Rico' },
  { codigo: 'PS', nombre: 'Palestina' },
  { codigo: 'PT', nombre: 'Portugal' },
  { codigo: 'PW', nombre: 'Palaos' },
  { codigo: 'PY', nombre: 'Paraguay' },
  { codigo: 'QA', nombre: 'Catar' },
  { codigo: 'RE', nombre: 'Reunión' },
  { codigo: 'RO', nombre: 'Rumania' },
  { codigo: 'RS', nombre: 'Serbia' },
  { codigo: 'RU', nombre: 'Rusia' },
  { codigo: 'RW', nombre: 'Ruanda' },
  { codigo: 'SA', nombre: 'Arabia Saudita' },
  { codigo: 'SB', nombre: 'Islas Salomón' },
  { codigo: 'SC', nombre: 'Seychelles' },
  { codigo: 'SD', nombre: 'Sudán' },
  { codigo: 'SE', nombre: 'Suecia' },
  { codigo: 'SG', nombre: 'Singapur' },
  { codigo: 'SH', nombre: 'Santa Elena' },
  { codigo: 'SI', nombre: 'Eslovenia' },
  { codigo: 'SJ', nombre: 'Svalbard y Jan Mayen' },
  { codigo: 'SK', nombre: 'Eslovaquia' },
  { codigo: 'SL', nombre: 'Sierra Leona' },
  { codigo: 'SM', nombre: 'San Marino' },
  { codigo: 'SN', nombre: 'Senegal' },
  { codigo: 'SO', nombre: 'Somalia' },
  { codigo: 'SR', nombre: 'Surinam' },
  { codigo: 'SS', nombre: 'Sudán del Sur' },
  { codigo: 'ST', nombre: 'Santo Tomé y Príncipe' },
  { codigo: 'SV', nombre: 'El Salvador' },
  { codigo: 'SX', nombre: 'Sint Maarten' },
  { codigo: 'SY', nombre: 'Siria' },
  { codigo: 'SZ', nombre: 'Esuatini' },
  { codigo: 'TC', nombre: 'Islas Turcas y Caicos' },
  { codigo: 'TD', nombre: 'Chad' },
  { codigo: 'TF', nombre: 'Territorios Australes Franceses' },
  { codigo: 'TG', nombre: 'Togo' },
  { codigo: 'TH', nombre: 'Tailandia' },
  { codigo: 'TJ', nombre: 'Tayikistán' },
  { codigo: 'TK', nombre: 'Tokelau' },
  { codigo: 'TL', nombre: 'Timor-Leste' },
  { codigo: 'TM', nombre: 'Turkmenistán' },
  { codigo: 'TN', nombre: 'Túnez' },
  { codigo: 'TO', nombre: 'Tonga' },
  { codigo: 'TR', nombre: 'Turquía' },
  { codigo: 'TT', nombre: 'Trinidad y Tobago' },
  { codigo: 'TV', nombre: 'Tuvalu' },
  { codigo: 'TW', nombre: 'Taiwán' },
  { codigo: 'TZ', nombre: 'Tanzania' },
  { codigo: 'UA', nombre: 'Ucrania' },
  { codigo: 'UG', nombre: 'Uganda' },
  { codigo: 'UM', nombre: 'Islas Ultramarinas de Estados Unidos' },
  { codigo: 'US', nombre: 'Estados Unidos' },
  { codigo: 'UY', nombre: 'Uruguay' },
  { codigo: 'UZ', nombre: 'Uzbekistán' },
  { codigo: 'VA', nombre: 'Ciudad del Vaticano' },
  { codigo: 'VC', nombre: 'San Vicente y las Granadinas' },
  { codigo: 'VE', nombre: 'Venezuela' },
  { codigo: 'VG', nombre: 'Islas Vírgenes Británicas' },
  { codigo: 'VI', nombre: 'Islas Vírgenes de Estados Unidos' },
  { codigo: 'VN', nombre: 'Vietnam' },
  { codigo: 'VU', nombre: 'Vanuatu' },
  { codigo: 'WF', nombre: 'Wallis y Futuna' },
  { codigo: 'WS', nombre: 'Samoa' },
  { codigo: 'YE', nombre: 'Yemen' },
  { codigo: 'YT', nombre: 'Mayotte' },
  { codigo: 'ZA', nombre: 'Sudáfrica' },
  { codigo: 'ZM', nombre: 'Zambia' },
  { codigo: 'ZW', nombre: 'Zimbabue' },
]

/**
 * El catálogo ordenado por nombre, que es el orden en que se elige.
 *
 * Con `localeCompare('es')` para que la Ñ y los acentos caigan donde los busca
 * quien lee: por orden de código, «España» quedaría entre «Eritrea» y «Etiopía».
 */
export const PAISES: readonly Pais[] = [...CATALOGO].sort((a, b) =>
  a.nombre.localeCompare(b.nombre, 'es'),
)

const POR_CODIGO = new Map(CATALOGO.map((p) => [p.codigo, p]))
const POR_NOMBRE = new Map(CATALOGO.map((p) => [normalizar(p.nombre), p.codigo]))

/** Sin acentos y en minúsculas: así «Perú» y «peru» buscan lo mismo. */
function normalizar(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .trim()
    .toLowerCase()
}

/** Cómo se escribe un país, o `null` si el código no es de la norma. */
export function nombrePais(codigo: string): string | null {
  return POR_CODIGO.get(codigo.trim().toUpperCase())?.nombre ?? null
}

/**
 * El código que corresponde a lo que se recibió, o `null` si no es un país.
 *
 * Acepta el código o el nombre porque no todo entra por el selector: quedaron
 * fichas cargadas cuando el campo era texto libre, y un import externo bien
 * puede traer «Costa Rica» en vez de «CR». Traducir acá es lo que evita perder
 * ese dato o guardarlo como un código que no existe.
 */
export function codigoPais(valor: string | null | undefined): string | null {
  const texto = valor?.trim() ?? ''
  if (texto.length === 0) return null

  const codigo = texto.toUpperCase()
  if (POR_CODIGO.has(codigo)) return codigo

  return POR_NOMBRE.get(normalizar(texto)) ?? null
}
